import React from 'react';

import { AmplitudeFlagKeys } from '../../resources/amplitude/amplitudeFlags';
import useIsExperimentActive from '../../resources/amplitude/useIsExperimentActive';

import { ServiceAreaWrapperV1 } from './ServiceAreaWrapperV1';
import { ServiceAreaWrapperV2 } from './ServiceAreaWrapperV2';

type Props = {
  children: React.ReactNode;
};

export const ServiceAreaWrapper = ({ children }: Props) => {
  const serviceAreaV2FlagEnabled = useIsExperimentActive(AmplitudeFlagKeys.serviceAreaV2);
  if (serviceAreaV2FlagEnabled) return <ServiceAreaWrapperV2>{children}</ServiceAreaWrapperV2>;

  return <ServiceAreaWrapperV1>{children}</ServiceAreaWrapperV1>;
};
